import { useAuth, useCachedDisplayData } from "../firebase";

const ROLE_HIERARCHY = ["viewer", "editor", "sharing", "admin"];
const EDIT_ROLES = ["editor", "admin"];

const hasRole = (userRole, requiredRole) => {
  const effectiveRole = userRole ?? "admin";
  return (
    ROLE_HIERARCHY.indexOf(effectiveRole) >=
    ROLE_HIERARCHY.indexOf(requiredRole)
  );
};

const canEditRole = (userRole) => {
  const effectiveRole = userRole ?? "admin";
  return EDIT_ROLES.includes(effectiveRole);
};

const usePermissions = () => {
  const [user] = useAuth();
  const { uid } = user || {};

  const [employees = [], permissionsLoading] =
    useCachedDisplayData("employees");
  const currentIndividual = employees.find(({ authUid }) => authUid === uid);
  const { role } = currentIndividual || {};

  return {
    role: role ?? "admin",
    canView: hasRole(role, "viewer"),
    canEdit: canEditRole(role),
    canShare: hasRole(role, "sharing"),
    isAdmin: hasRole(role, "admin"),
    permissionsLoading
  };
};

export default usePermissions;
